'use client'

import { useDynamicI18n } from '@/hooks/use-dynamic-i18n'

type TTemplateDescriptionProps = {
  description: string
}

/**
 * Client component to render translated template description
 * @param description - Template description text
 * @returns Translated template description
 */
export function TemplateDescription({
  description,
}: TTemplateDescriptionProps) {
  const { dt } = useDynamicI18n()

  return (
    <div className="text-sm text-white leading-relaxed">{dt(description)}</div>
  )
}
